/**
 * Created by Karol on 2015-12-15.
 */
var module = angular.module('meternet.dashboard.controllers.eventsAckWidget', [ 'adf.provider', 'i18n',
    'meternet.dashboard.constants' ]);

module.config(function(dashboardProvider, contextPath, messages) {
    var widget = {
        templateUrl : 'dashboard/events-ack-widget.html',
        title : messages['dashboard.widgets.eventsAckWidget.title'],
        description : messages['dashboard.widgets.eventsAckWidget.title'],
        controller : 'EventsAckWidgetCtrl',
        resolve : {
        },
        config : {
            dashboardId: null
        }
    };

    dashboardProvider.widget('events-ack-widget', widget);

});

function EventsAckWidgetEditCtrl($scope,configService) {

}

function EventsAckWidgetCtrl($scope, $timeout, configService, eventAckService, $sce, i18nFilter){
    var templates = {};

    function updateSources() {
        configService.get().then(function (config) {
            $scope.sources = {};
            _.each(config.engine.eventInputs, function (input) {
                _.each(input.sources, function (source) {
                    var s = {
                        config: source
                    };
                    $scope.sources[source.sourceId] = s;
                });
            });
            _.each($scope.sources, function (source) {
                source.path = "";
                _.each(source.config.path, function (id) {
                    var s = $scope.sources[id];
                    source.path += (s.config.label || s.config.name);
                    if (id !== source.config.sourceId) {
                        source.path += " / ";
                    }
                });
            });
        });
    }

    function updateEvents() {
        if ($scope.current) {
            eventAckService.currentLevel($scope.level, true, $scope.acked);
            $scope.events = eventAckService.currentEvents();
        } else {
            eventAckService.findEvents($scope.timestamp, $scope.level, $scope.offset, null, true, $scope.acked).then(function (events) {
                $scope.events = events;
            })
        }
    }

    updateSources();


    $scope.ui = {
        levels: [ {
            value: null,
            label: 'event.level.all'
        }, {
            value: 0,
            label: 'event.level.info'
        }, {
            value: 1,
            label: 'event.level.warning'
        }, {
            value: 2,
            label: 'event.level.error'
        } ],
        source: function (event) {
            var info = "";
            var source = $scope.sources[event.sourceId];
            if (source) {
                info = i18nFilter('config.componentType.' + source.config.sourceType) + ' <b>' + source.path + '</b>';
            } else {
                info = "???";
            }
            return info;
        },
        message: function (event) {
            var template = templates[event.type];
            if (!template) {
                var msg = i18nFilter('event.' + event.type);
                template = _.template(msg);
                templates[event.type] = template;
            }
            return template(event.data);
        },
        display: function (event) {
            if (!event._msg) {
                event._msg = $sce.trustAsHtml(this.source(event) + ': ' + this.message(event));
            }
            return event._msg;
        },
        stop: function () {
            $scope.current = false;
            updateEvents();
        },
        start: function () {
            $scope.current = true;
            $scope.timestamp = null;
            updateEvents();
        },
        prev: function () {
            $scope.offset += 100;
            updateEvents();
        },
        next: function () {
            var offset = $scope.offset >= 100 ? $scope.offset - 100 : 0;
            if (offset !== $scope.offset) {
                $scope.offset = offset;
                updateEvents();
            }
        },
        ackEvent: function(event) {
            eventAckService.ackEvent(event.timestamp, event.sourceId, event.comment).then(function(event){
                var eventToUpdate = _.find($scope.events, function(e){
                    return ((new Date(e.timestamp).getTime() == new Date(event.timestamp).getTime() )&& (e.sourceId === event.sourceId));
                })
                if(eventToUpdate){
                    eventToUpdate.ack_timestamp = event.ack_timestamp;
                    eventToUpdate.comment = event.comment;
                }
                if($scope.acked){
                    $timeout(function() {
                        $scope.offset = 0;
                        $scope.events = _.filter($scope.events, function(e){
                            return !e.ack_timestamp;
                        })
                    }, 2000);
                }
            });
        }
    };

    $scope.current = true;
    $scope.timestamp = null;
    $scope.level = eventAckService.currentLevel();
    $scope.offset = 0;
    $scope.acked = false;

    updateEvents();

    $scope.$watch('level', function (nval, oval) {
        if (nval !== oval) {
            $scope.offset = 0;
            updateEvents();
        }
    });

    $scope.$watch('timestamp', function (nval, oval) {
        if (nval !== oval) {
            $scope.current = nval == null;
            $scope.offset = 0;
            updateEvents();
        }
    });

    $scope.$watch('acked', function (nval, oval) {
        if (nval !== oval) {
            updateEvents();
        }
    });
}

module.controller('EventsAckWidgetEditCtrl', EventsAckWidgetEditCtrl);
module.controller('EventsAckWidgetCtrl', EventsAckWidgetCtrl);